module.exports = __webpack_public_path__ + "assets/img/0861.92c7f873.svg";